import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import { useTranslation } from 'react-i18next';
import { isTrue } from '@/utils/Common/Booleans';
import * as Accordion from '@radix-ui/react-accordion';
import useFetchEnquiryTypes from '@/hooks/useFetchEnquiryTypes';
import Icon from '@/components/atoms/Icon';
import useMatchMedia from '@/hooks/useMatchMedia';
import EnquirySelector from './EnquirySelector';

export const DynamicFormLazy = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dynamic-form" */ '@/contact-us/DynamicForm'),
  loading: () => <div />,
});

const DynamicFormAccordion = ({ onSuccess }) => {
  const { t } = useTranslation();
  const forceOpen = useMatchMedia('(min-width:600px)');
  const {
    enquiryTypes,
    selectedEnquiry,
    onSelectEnquiry,
    formDynamicForm,
  } = useFetchEnquiryTypes();

  return (
    <Accordion.Root
      className='dln-contactUs__accordion'
      collapsible
      value={forceOpen ? 'open' : undefined}
    >
      <Accordion.Item value='open'>
        <Accordion.Trigger className='dln-contactUs__accordionTrigger'>
          <>
            <Icon glyph='w' modifiers={['main']} />
            <h2 className='dln-contactUs__accordionTitle'>
              {t('contact-us:contact.us.write.us.title')}
            </h2>
            <Icon glyph='u' modifiers={['arrow-down']} />
          </>
        </Accordion.Trigger>
        <Accordion.Content className='dln-contactUs__accordionContent'>
          {isTrue(DLG.config.contactUsFormEnabled) && enquiryTypes ? (
            <>
              <h2 className='dln-contactUs__title'>
                {t('contact-us:contact.us.form.title')}
              </h2>
              <p className='dln-contactUs__text'>
                {t('contact-us:contact.us.form.subtitle')}
              </p>
              {Array.isArray(enquiryTypes) && (
                <EnquirySelector
                  items={enquiryTypes || []}
                  value={selectedEnquiry.code || ''}
                  onChange={onSelectEnquiry}
                />
              )}
              {formDynamicForm && (
                <DynamicFormLazy
                  form={formDynamicForm}
                  enquiry={selectedEnquiry}
                  successCB={onSuccess}
                />
              )}
            </>
          ) : (
            <div>
              <h2 className='dln-contactUs__title'>
                {t('contact-us:contact.us.noform.title')}
              </h2>
              <p className='dln-contactUs__text'>
                {t('contact-us:contact.us.noform.subtitle')}
              </p>
            </div>
          )}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};

DynamicFormAccordion.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
DynamicFormAccordion.defaultProps = {};

export default DynamicFormAccordion;
